import { NavLink } from 'react-router';

import './banner-title.scss';

const slideInterval = 2000; // Interval in milliseconds for each slide

export default function BannerTitle() {
  return (
    <div className="banner-title">
      <div className="container">
        <div id="bannerTitleCarousel" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#bannerTitleCarousel"
              data-bs-slide-to="0"
              className="active"
              aria-current="true"
              aria-label="Slide 1"
            ></button>
            <button type="button" data-bs-target="#bannerTitleCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active" data-bs-interval={slideInterval}>
              <div className="banner-w3lstext">
                <h5>Българска Федерация по кънки</h5>
                <h1>
                  <NavLink to="/figure-skating">Фигурно Пързаляне</NavLink>
                </h1>
                <p>Моля, изберете спорта, който искате да видите.</p>
              </div>
            </div>
            <div className="carousel-item" data-bs-interval={slideInterval}>
              <div className="banner-w3lstext">
                <h5>Българска Федерация по кънки</h5>
                <h1>
                  <NavLink to="/shorttrack">Шорттрек</NavLink>
                </h1>
                <p>Моля, изберете спорта, който искате да видите.</p>
              </div>
            </div>
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#bannerTitleCarousel" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#bannerTitleCarousel" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </div>
  );
}
